/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/ImageViewer/PatientAge/Content"
  
}) {
let patientPersonBirthDateValueData = fromData.useDataFormat({ viewPath,
context: 'patient',
path: 'person.birth_date',
format: fromFormat.ageInYearsAndMonths,
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h3"
 marginLeft={dtSpaceS}
 data="patient.person.birth_date"
 format="/Data/format.js ageInYearsAndMonths"
 text={patientPersonBirthDateValueData}
/>
{children}
</React.Fragment>)
}